import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import CompanyLogo from '../../assets/company-logo.png';

import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../firebase';
import ForgotPassword from '../ForgotPassword';
import Version from '../../version';
import { useNavigate } from 'react-router-dom';
import { db } from '../../firebase';
import { getDocs, collection, where, query } from 'firebase/firestore';
//import Recaptcha from '../../components/PageDesigner/Library/Components/Recaptcha';

const Login = ({ siteMap }) => {
  const navigate = useNavigate();
  const [loginError, setLoginError] = useState();
  const [creds, setCreds] = useState({ email: '', password: '' });
  const [showForgotPassword, setShowForgotPassword] = useState();
  const user = useSelector(state => state.User);

  useEffect(() => {
    if (Object.keys(user).length > 1) {
      //dispatch({ type: 'USER_LOGOUT', payload: {} });
    }
  }, [user]);

  const signIn = async e => {
    e.preventDefault();
    signInWithEmailAndPassword(auth, creds.email, creds.password)
      .then(async userCredential => {
        const user = userCredential.user;

        await user.getIdToken(true);
        const decodedToken = await auth.currentUser.getIdTokenResult();

        let homePath = '/';

        if (decodedToken?.claims?.role) {
          // authorised_roles will not be loaded yet so just go and query for the one we are interested in
          const rolesQuery = query(
            collection(db, 'authorised_roles'),
            where('role', '==', decodedToken?.claims?.role)
          );

          const rolesSnapshot = await getDocs(rolesQuery);
          let roles = [];
          rolesSnapshot.forEach(async doc => {
            roles.push(doc.data());
          });

          if (roles.length === 1 && roles[0].homePath?.trim().length > 0) {
            homePath = roles[0].homePath;
          }
        }

        navigate(homePath);
      })
      .catch(error => setLoginError(error));
  };

  return (
    <>
      {showForgotPassword && (
        <ForgotPassword
          email={creds.email}
          close={() => setShowForgotPassword(false)}
          open={showForgotPassword}
        />
      )}
      {!showForgotPassword && (
        <div
          className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8"
          data-testid="login">
          <div className="sm:mx-auto sm:w-full sm:max-w-md">
            <img
              className="mx-auto h-12 w-auto mb-6"
              src={CompanyLogo}
              alt=""
            />
            <h2 className="mt-8 text-center text-3xl font-extrabold text-gray-900">
              Sign in to your account
            </h2>
          </div>

          <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
              {loginError && (
                <div className="text-red-700 mb-2">{loginError.message}</div>
              )}
              {user?.invalidUser && (
                <div className="text-red-700 mb-2">
                  This account is not authorised to login.
                </div>
              )}
              <form className="space-y-6" action="#" method="POST">
                <div data-testid="emailField">
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-700">
                    Email address
                  </label>
                  <div className="mt-1">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      onChange={e =>
                        setCreds({ ...creds, email: e.target.value })
                      }
                      autoComplete="email"
                      required
                      className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                  </div>
                </div>

                <div data-testid="passwordField">
                  <label
                    htmlFor="password"
                    className="block text-sm font-medium text-gray-700">
                    Password
                  </label>
                  <div className="mt-1">
                    <input
                      data-testid="passwordInput"
                      id="password"
                      name="password"
                      type="password"
                      onChange={e =>
                        setCreds({ ...creds, password: e.target.value })
                      }
                      autoComplete="current-password"
                      required
                      className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <input
                      data-testid="rememberMeCheckbox"
                      id="remember-me"
                      name="remember-me"
                      type="checkbox"
                      className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                    />
                    <label
                      htmlFor="remember-me"
                      className="ml-2 block text-sm text-gray-900">
                      Remember me
                    </label>
                  </div>

                  <div className="text-sm">
                    <a
                      data-testid="lnkForgotPassword"
                      href="http://"
                      onClick={e => {
                        e.preventDefault();
                        setShowForgotPassword(true);
                      }}
                      className="font-medium text-activecourse-blue hover:text-activecourse-orange">
                      Forgot your password?
                    </a>
                  </div>
                </div>

                <div>
                  <button
                    data-testid="loginButton"
                    type="submit"
                    onClick={e => signIn(e)}
                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-button-text bg-button-bg hover:bg-button-bg-hover hover:text-button-text-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    Sign in
                  </button>
                </div>
                <Version />
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default Login;
